module.exports = __webpack_public_path__ + "img/device-Information_0.c19ef3f4.png";